import {FormikValues, useFormikContext} from 'formik'
import React from 'react'

interface TextAreaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  className?: string
  name: string
  label?: string
}

const TextArea = (props: TextAreaProps) => {
  const {className = '', name, label, ...rest} = props
  const {values, handleChange, handleBlur, errors, touched} = useFormikContext<FormikValues>()

  const typedValues = values as Record<string, any>

  return (
    <>
      {label && <div className='mb-1 fw-bold'><label htmlFor={name}>{label}</label></div>}
      <textarea
        className={`form-control ${className} ${touched[name] && errors[name] ? 'is-invalid' : ''}`}
        name={name}
        value={typedValues[name]}
        rows={4}
        {...rest}
        onChange={handleChange}
        onBlur={handleBlur}
      />

      {touched[name] && errors[name] && (
        <div className="text-danger mt-1 fw-bold" style={{ fontSize: '0.9em' }}>
          {errors[name] as any}
        </div>
      )}
    </>
  )
}

export default TextArea
